// Oppslag mot hubbens katalog over ALLE registrerte GNÅ-brukere.
//
// Eierkrav 2026-08-13: «absolutt alle som har registrert seg i GNÅ SKAL finnes i
// kontakter i SKADE». Kilden er Synapse, men klienten spør ALDRI Synapse selv —
// admin-tokenet ligger i hubben (`GET /gna/brukere`), og skal aldri nå
// nettleseren.
//
// Ligger som egen modul fordi BÅDE Kontakter-panelet og Feltveksleren trenger
// den, i tillegg til de frittstående popout-vinduene. Ett oppslag, ett sted å
// rette.

export interface GnaKatalogBruker {
  matrixId: string;
  navn: string;
  nummer: string;
}

/**
 * Søk i katalogen. Tom liste ved feil eller når hubben mangler admin-token —
 * kallerne behandler katalogen som et TILLEGG til lokale kontakter, så et
 * mislykket oppslag skal aldri gjøre kontaktlista ubrukelig.
 */
export async function sokGnaBrukere(q: string): Promise<GnaKatalogBruker[]> {
  const r = await fetch(`/gna/brukere?q=${encodeURIComponent(q)}`, { credentials: 'include' });
  if (!r.ok) return [];
  const data = (await r.json()) as {
    konfigurert?: boolean;
    brukere?: { matrixId?: unknown; navn?: unknown; nummer?: unknown }[];
  };
  // `konfigurert: false` = hubben mangler MATRIX_ADMIN_TOKEN. Da er tom liste
  // det ærlige svaret; vi later ikke som at ingen brukere finnes.
  if (!data.konfigurert || !Array.isArray(data.brukere)) return [];
  return data.brukere.flatMap((b) =>
    typeof b.matrixId === 'string' && b.matrixId
      ? [{
          matrixId: b.matrixId,
          navn: typeof b.navn === 'string' && b.navn ? b.navn : b.matrixId,
          nummer: typeof b.nummer === 'string' ? b.nummer : '',
        }]
      : [],
  );
}
